import axios from "axios";
import CommonApi from "./CommonApi";


export default class GoAroundApi {
    static async addGoAroundData(ConstructionSiteId,Data){
        const res=await axios.post( CommonApi.getHost()+"/GoAround/addGoAroundData",  {GoAround:{ConstructionSiteId:ConstructionSiteId, Data:Data}})
        return res.data;
    }
    static async addImage(Image, House, Floor){
        const FormData=new window.FormData();
        FormData.append('image', Image)
        FormData.append('house', House)
        FormData.append('floor', Floor)
        const res=await axios.post( CommonApi.getHost()+"/GoAround/addImage",  FormData)
        return res.data;
    }
}